//import data from "./articles/brexit";
//import data from "./articles/airbus-a320";
//import data from "./articles/en-hel-by-tystnar";
//import data from "./articles/hyrestestet-tack";
//import data from "./articles/krisen-i-miljopartiet";
//import data from "./articles/gammal-bil";
//import data from "./articles/zika";
//import data from "./articles/historien-om-zika";
//import data from "./articles/efter-flykten";
import data from "./articles/efter-flykten-mottagandet";
//import data from "./articles/demo";



export default data;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/index.js
 **/